import Login from "@/pages/login";
import { lazyPage } from "@/routes/lazyPage";
import { ReportingSwitch } from "@/routes/routeMatchScope";

import { Route } from "wouter";

const FreeTrial = lazyPage(() => import("@/pages/free-trial"));
const TrySampleAccount = lazyPage(() => import("@/pages/try"));
const Register = lazyPage(() => import("@/pages/register"));
const AcceptInvitation = lazyPage(() => import("@/pages/accept-invitation"));
const ChooseOrganization = lazyPage(() => import("@/pages/choose-organization"));
const Pricing = lazyPage(() => import("@/pages/pricing"));
const PrivacyNotice = lazyPage(() => import("@/pages/privacy-notice"));
const CookiePolicy = lazyPage(() => import("@/pages/cookie-policy"));
const TermsOfUse = lazyPage(() => import("@/pages/terms-of-use"));
const SubjectAccessRequest = lazyPage(() => import("@/pages/subject-access-request"));
const ApiDocsPage = lazyPage(() => import("@/pages/api-docs"));
const PublicCustomerConsentPage = lazyPage(
  () => import("@/pages/helpline/public-customer-consent"),
);
const PublicHelplineSupplementalReportPage = lazyPage(
  () => import("@/pages/helpline/public-supplemental-report"),
);
const PublicHelplineReportPage = lazyPage(() => import("@/pages/helpline/public-report"));

export default function PublicRoutesSwitch() {
  return (
    <ReportingSwitch>
      <Route path="/login" component={Login} />
      <Route path="/free-trial" component={FreeTrial} />
      <Route path="/try" component={TrySampleAccount} />
      <Route path="/register" component={Register} />
      <Route path="/sign-up" component={Register} />
      <Route path="/accept-invitation" component={AcceptInvitation} />
      <Route path="/choose-organization" component={ChooseOrganization} />
      <Route path="/pricing" component={Pricing} />
      <Route path="/privacy-notice" component={PrivacyNotice} />
      <Route path="/cookie-policy" component={CookiePolicy} />
      <Route path="/terms-of-use" component={TermsOfUse} />
      <Route path="/subject-access-request" component={SubjectAccessRequest} />
      <Route path="/api-docs" component={ApiDocsPage} />
      <Route
        path="/report-incident/customer-consent/:token"
        component={PublicCustomerConsentPage}
      />
      <Route
        path="/report-incident/supplement/:token"
        component={PublicHelplineSupplementalReportPage}
      />
      <Route path="/report-incident/:token" component={PublicHelplineReportPage} />
    </ReportingSwitch>
  );
}
